import axios from 'axios';
import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { handleHttpError } from '../utils/common';

export interface OnlyFansMetricsPublicDataCounters {
    _id: string;
    payload: any;
}

const useSextforcePublicMetricCounters = (timezone: string, metricShareLinkId: string | undefined, metricId: string | undefined) => {
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();

    // Retrieve subscriber data
    const fetchMetric = async (): Promise<OnlyFansMetricsPublicDataCounters[]> => {
        const query: string = `${settingsContext.routes.sextforce.publicMetrics}${metricShareLinkId}/counters/${metricId}?timezone=${timezone}`;

        return axios
            .get(query, {
                method: 'get',
                headers: {
                    apiKey: settingsContext.apiKey,
                },
            })
            .then(response => response.data);
    };

    return useQuery(['publicMetricCounters', metricShareLinkId, metricId, timezone], () => fetchMetric(), {
        refetchOnWindowFocus: false,
        staleTime: 0,
        enabled: metricShareLinkId && metricId ? true : false,
        retry: 0,
        onError: (error: any) => {
            if (error && error.response && error.response.data && error.response.data.status && error.response.data.status === 400) {
                dialog
                    .alert({
                        message: 'Link does not exist or expired',
                        title: 'Error',
                        ok: {
                            text: 'OK',
                            color: 'primary',
                            variant: 'contained',
                        },
                    })
                    .then(() => {});

                return null;
            }

            handleHttpError(error, dialog);
        },
    });
};

export default useSextforcePublicMetricCounters;
